// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"ProductPhotoGrid_imageWrapper__Vp3ir","solo":"ProductPhotoGrid_solo__l709O","video":"ProductPhotoGrid_video___VIV_","image":"ProductPhotoGrid_image__ZosZZ"};